import { createTypes } from "./createTypes";

export default createTypes(
  "GET_DEVICES",
  "REMOVE_DEVICE",
  "CHANGE_SUBSCRIPTION",
  "GET_NEWS_DATA",
  "GET_PLAY_COUNTDOWN"
);
